"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObjectToArray = ObjectToArray;
exports.ArrayToObject = ArrayToObject;
exports.bbGenders = exports.ticketSourceList = exports.defaultLevelMap = exports.contactShopResult = exports.complainUpgradeType = exports.returnFacMap = exports.pVersionsV2 = exports.pVersions = exports.boolenMap = exports.typeMap = exports.relationsMap = exports.defaultTypeMap = exports.resultMap = exports.substatusDesc = exports.statusDesc = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

//工单状态
var statusDesc = {
  0: "创建",
  1: "待处理",
  2: "已完成",
  // 3: "作废",
  9: "处理中"
}; //工单子状态

exports.statusDesc = statusDesc;
var substatusDesc = {
  101: "待处理CSR",
  102: "待处理TL",
  103: "流转TL",
  104: "重新打开",
  106: "等待客户上传图片",
  107: "客户已上传图片",
  201: "完成",
  301: "作废",
  0: "创建"
}; //电访结果

exports.substatusDesc = substatusDesc;
var resultMap = {
  0: "未拨打",
  1: "个人回拨",
  2: "无应答",
  3: "通话中",
  4: "关机",
  5: "停机",
  6: "成功",
  7: "空号",
  8: "无法接通",
  9: "拒访"
}; //客户类型

exports.resultMap = resultMap;
var defaultTypeMap = [{
  label: "a2用户",
  value: "a2用户"
}, {
  label: "门店",
  value: "门店"
}, {
  label: "政府机关",
  value: "政府机关"
}, {
  label: "媒体",
  value: "媒体"
}, {
  label: "经销商",
  value: "经销商"
}, {
  label: "潜在用户",
  value: "潜在用户"
}, {
  label: "其他",
  value: "其他"
}]; //宝宝关系

exports.defaultTypeMap = defaultTypeMap;
var relationsMap = [{
  label: 72,
  value: "母亲"
}, {
  label: 73,
  value: "父亲"
}, {
  label: 74,
  value: "其他亲戚"
}, {
  label: 75,
  value: "经销商"
}, {
  label: 76,
  value: "门店促销员"
}, {
  label: 77,
  value: "其他"
}]; //呼叫类型

exports.relationsMap = relationsMap;
var typeMap = {
  IB: "呼入",
  OB: "呼出"
};
exports.typeMap = typeMap;
var boolenMap = [{
  id: '',
  name: "请选择"
}, {
  id: false,
  name: "否"
}, {
  id: true,
  name: "是"
}]; //产品版本

exports.boolenMap = boolenMap;
var pVersions = [{
  id: "中文版",
  name: '中文版'
}, {
  id: "澳洲版",
  name: '澳洲版'
}, {
  id: "UHT",
  name: 'UHT'
}, {
  id: "中文版/澳洲版",
  name: '中文版/澳洲版'
}, {
  id: "澳洲版/香港版",
  name: '澳洲版/香港版'
}, {
  id: "中文版/澳洲版/香港版",
  name: '中文版/澳洲版/香港版'
}, {
  id: "鲜奶",
  name: '鲜奶'
}]; //产品版本

exports.pVersions = pVersions;
var pVersionsV2 = [{
  id: "UHT",
  name: 'UHT'
}, {
  id: "中文版",
  name: '中文版'
}, {
  id: "澳洲版",
  name: '澳洲版'
}, {
  id: "香港版",
  name: '香港版'
}, {
  id: "鲜奶",
  name: '鲜奶'
}];
exports.pVersionsV2 = pVersionsV2;
var returnFacMap = [{
  id: 0,
  name: "不需要"
}, {
  id: 1,
  name: "需要退回-有实物"
}, {
  id: 2,
  name: "需要退回-无实物"
}];
exports.returnFacMap = returnFacMap;
var complainUpgradeType = [{
  id: 0,
  name: "否"
}, {
  id: 1,
  name: "威胁"
}, {
  id: 2,
  name: "已投诉"
}]; //是否联系门店

exports.complainUpgradeType = complainUpgradeType;
var contactShopResult = [{
  id: 0,
  name: "未联系门店"
}, {
  id: 1,
  name: "已联系门店，解释不满意"
}, {
  id: 2,
  name: "已联系门店，解释满意"
}, {
  id: 3,
  name: "已联系渠道，渠道未解答"
}];
exports.contactShopResult = contactShopResult;
var defaultLevelMap = [{
  label: 0,
  value: "无"
}, {
  label: 1,
  value: "一般"
}, {
  label: 2,
  value: "严重"
}, {
  label: 3,
  value: "非常严重"
}];
exports.defaultLevelMap = defaultLevelMap;
var ticketSourceList = [{
  label: "400进线",
  value: "IB"
}, {
  label: "日常回访",
  value: "OB"
}, {
  label: "XP反馈",
  value: "XP"
}, {
  label: "在线chat",
  value: "IM"
}, {
  label: "钉钉反馈",
  value: "DD"
}, {
  label: "APP差评",
  value: "HMAPP"
}, {
  label: "抖音",
  value: "DY"
}, {
  label: "美团",
  value: "MT"
}, {
  label: "快手",
  value: "KS"
}, {
  label: "企微反馈",
  value: "CP"
}, {
  label: "勤鸽XP",
  value: "QG"
}, {
  label: "阿姨自主报备",
  value: "SS"
}, {
  label: "鲸简",
  value: "JJ"
}, {
  label: "保姆工具",
  value: "APP"
}, {
  label: "公众号",
  value: "WX"
}, {
  label: "其他",
  value: "OT"
}, {
  label: "回访话务",
  value: "CallRecord"
}, {
  label: "客户中心",
  value: "Customer"
}, {
  label: "抖音领客",
  value: "LK"
}, {
  label: "抖音电信",
  value: "DX"
}]; //宝宝性别

exports.ticketSourceList = ticketSourceList;
var bbGenders = [{
  id: 1,
  name: "男宝宝"
}, {
  id: 2,
  name: "女宝宝"
}, {
  id: 3,
  name: "双胞胎男宝"
}, {
  id: 4,
  name: "双胞胎女宝"
}, {
  id: 5,
  name: "龙凤胎"
}, {
  id: 0,
  name: "未知"
}]; //object对象转数组

exports.bbGenders = bbGenders;

function ObjectToArray(obj) {
  var objArray = Object.keys(obj).map(function (key) {
    return {
      value: key,
      label: obj[key]
    };
  });
  return objArray;
} //队列转对象


function ArrayToObject(array) {
  var jsonStr = "{";
  var index = 0;
  array.forEach(function (item) {
    if (index == 0) jsonStr = jsonStr + "\"" + item.label + "\":\"" + item.value + "\"";else jsonStr = jsonStr + ",\"" + item.label + "\":\"" + item.value + "\"";
    index = index + 1;
  });
  jsonStr = jsonStr + "}";
  return JSON.parse(jsonStr);
}